import { FC } from 'react';

import { useHotkeys } from 'react-hotkeys-hook';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { useTableContext } from '@shared/components/Table';
import { IMeta } from '@shared/types/fetch-data';

import '../pagination.css';

interface IProps {
  data: IMeta;
}

function isPrev(label: string) {
  return label.toLowerCase().includes('prev');
}

function isNext(label: string) {
  return label.toLowerCase().includes('next');
}

export const Pagination: FC<IProps> = ({ data }) => {
  const { setPage } = useTableContext();

  useHotkeys('shift+left', () => {
    if (!data.links) return;
    const prevLink = data.links.find(link => isPrev(link.label) && link.url);
    if (prevLink?.url) {
      const page = new URL(prevLink.url).searchParams.get('page') || '1';
      setPage(page);
    }
  });

  useHotkeys('shift+right', () => {
    if (!data.links) return;
    const nextLink = data.links.find(link => isNext(link.label) && link.url);
    if (nextLink?.url) {
      const page = new URL(nextLink.url).searchParams.get('page') || '1';
      setPage(page);
    }
  });

  if (!data.links) return null;

  return (
    <>
      <div className='pagination'>
        {data.links.map(({ active, label, url }) => {
          const page = (url ? new URL(url).searchParams.get('page') : '1') || '1';

          return (
            <div
              key={label}
              className={`page-item${active ? ' is-active' : ''}${url ? '' : ' is-disabled'}`}
              onClick={() => setPage(page)}
              onKeyDown={() => setPage(page)}
              role='button'
              tabIndex={0}
            >
              {isPrev(label) ? (
                <ArrowBackIosNewIcon />
              ) : isNext(label) ? (
                <ArrowForwardIosOutlinedIcon />
              ) : (
                label
              )}
            </div>
          );
        })}
      </div>
      <div className='pagination-counter'>
        <b>{data.from}</b> to <b>{data.to}</b> of <b>{data.total}</b>
      </div>
    </>
  );
};
